"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsetGroup = void 0;
var React = require("react");
var legendStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0,0,0,0)',
    whiteSpace: 'nowrap',
    border: 0
};
var FieldsetGroup = (function (_super) {
    __extends(FieldsetGroup, _super);
    function FieldsetGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldsetGroup.prototype.render = function () {
        return (React.createElement("fieldset", { style: { border: 'none', margin: 0, padding: 0 } },
            React.createElement("legend", { style: legendStyle }, this.props.legend),
            this.props.children));
    };
    return FieldsetGroup;
}(React.Component));
exports.FieldsetGroup = FieldsetGroup;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["FieldsetGroup"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/FieldsetGroup/FieldsetGroup.js
// module id = 202
// module chunks = 0 1